import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";

const CompanyListComponent = (props) => {
  const [company, setCompany] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      window.App.setState({rerenderCompanyList: false})
      let query = window.App.transformQueryParams(lazyParams)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_HOST + "/api/v2/company" + query,
        params: {
          page: (lazyParams.page ?? 0) + 1,
          item_per_page: lazyParams.rows ?? rows
        },
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
        .then(response => {
          const payload = response?.data?.data || {};
          setTotalRecords(payload.total_item_count || 0);
          setCompany(Array.isArray(payload.items) ? payload.items : []);
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {localStorage.getItem('roles').toString().includes('role_company_update') &&
        <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                tooltip={props.t('edit')} tooltipOptions={{ position: 'left' }}
                onClick={() => {
                  window.App.setState({
                    sidebarCompanyUpdate: true,
                    props: rowData
                  })
                }}/>
        }
        {/*{localStorage.getItem('roles').toString().includes('role_company_write') &&*/}
        {/*<Button icon="pi pi-trash" className=" p-button-danger"*/}
        {/*        tooltip={props.t('delete')}*/}
        {/*        onClick={() => {*/}
        {/*          if (window.confirm('A törlés megerősítésére van szükség!')) {*/}
        {/*            deleteCompany(rowData)*/}
        {/*          }*/}
        {/*        }}*/}
        {/*/>*/}
        {/*}*/}
      </React.Fragment>
    );
  }

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderCompanyList === true])

  return (
    <>
      {/* {props && props.view === 'simple' &&
        <>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
              {localStorage.getItem('roles').toString().includes('role_company_create') && process.env.REACT_APP_BRAND !== 'trackie' &&
                <a onClick={() => window.App.setState({sidebarCompanyCreate: true})}
                   className={"p-button  p-button-success"}>
                  <i className={"pi pi-plus"}></i>
                  &nbsp;
                  {props.t('addCompany')}
                </a>
              }
            </div>
          </div>
        </>
      } */}
      <DataTable size={localStorage.getItem('scale')}
        emptyMessage={props.t('noResults')}
        value={company} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
        paginatorTemplate={pager} rows={rows}
        autoLayout={true}
        filterDisplay="row"
        responsiveLayout="scroll"
        stripedRows
      >
        <Column field="name" header={props.t('columnName2')} bodyClassName="col-body-font-bold" sortable filter ></Column>
        <Column field="address_city" header={props.t('columnAddress')} sortable filter filterPlaceholder={props.t('columnAddress')}
                body={(rowData) => {
                  return (
                    <>{rowData.address_postal_code} {rowData.address_city}{rowData.address_detail && <>, {rowData.address_detail}</>} {rowData.address_country_code}</>
                  )
                }}
        ></Column>
        <Column field="vat_number" header={props.t('columnTaxNumber')} sortable filter filterPlaceholder={props.t('columnTaxNumber')}></Column>
        <Column field="active" header={props.t('fieldActive')} body={row => props.t(row.active ? 'yes' : 'no')}/>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(CompanyListComponent);
